import core from './core'

// 输出模块
export default core



// WEBPACK FOOTER //
// ./src/core/index.js